export const ClaimReason = {
  CRASH: 'Crash',
  THEFT: 'Theft',
  LOSS: 'Loss',
  OTHER: 'Other',
}
